import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ProductCardLarge from '~/components/common/ProductCardLarge/ProductCardLarge';

import { Keyboard, Mousewheel, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { api_getBannersByBannerGroupName, api_getFeaturedProducts } from '~/backend/api_calls';
import { convertImageUrl_L_to_F } from '~/backend/helper';
import { viewItemListGTAG4Event } from '~/common/gtag4';
import { attachIndexesToProducts } from '~/common/helper';
import { SalesProductsLoader } from '~/components/common/SkeletonLoaders';

const SalesProducts = () => {
	const { t } = useTranslation();
	const groupName = 'SalesBanner';
	const [loading, setLoading] = useState(false);
	const [banner, setBanner] = useState(null);
	const [products, setProducts] = useState([]);
	const [hasSentEvent, setHasSentEvent] = useState(false);

	useEffect(() => {
		if (!hasSentEvent && products.length > 0) {
			viewItemListGTAG4Event(attachIndexesToProducts(products), 'Sales Products');
			setHasSentEvent(true);
		}
	}, [hasSentEvent, products]);

	useEffect(() => {
		api_getBannersByBannerGroupName(groupName)
			.then(json => {
				if (json.items.length > 0) setBanner(json.items[0]);
			})
			.catch(error => {
				console.log(error);
			});

		setLoading(true);
		api_getFeaturedProducts(groupName)
			.then(json => {
				setProducts(json.items);
			})
			.catch(error => {
				console.log(error);
			})
			.finally(() => setLoading(false));
	}, []);

	return (
		<div className="salesproducts">
			<Link to={banner?.nu}>
				<div className="banner-img">
					<img src={convertImageUrl_L_to_F(banner?.img1) ?? banner?.img2} alt={banner?.tl} />
					<div className="triangle-up"></div>
				</div>
			</Link>
			<div className="content-wrapper">
				<div className="salesproducts-slider-container">
					{loading ? (
						<SalesProductsLoader />
					) : (
						<Swiper
							cssMode={true}
							navigation={true}
							pagination={{ clickable: true }}
							mousewheel={true}
							keyboard={true}
							modules={[Navigation, Pagination, Mousewheel, Keyboard]}
							className="mySwiper">
							{products
								.filter((product, index) => index <= 11)
								.map((product, index) => (
									<Link to={product.eurl} key={product.id}>
										<SwiperSlide key={product.id}>
											<ProductCardLarge product={product} />
										</SwiperSlide>
									</Link>
								))}
						</Swiper>
					)}
				</div>
			</div>
		</div>
	);
};

export default SalesProducts;
